import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from 'react-bootstrap';

import { useStateValue } from '../context/state.jsx';
import { setProjectFilterReset } from '../context/projectFilter.js';

const FlyoutRightButtons = ({ setIsFlyoutRightActive, closeButtonRef, onRequestClose }) => {
	const [, dispatch] = useStateValue();

	const closeButtonClick = () => {
		if (typeof onRequestClose === 'function') {
			onRequestClose();
			return;
		}
		setIsFlyoutRightActive(false);
	};

	const resetFilter = () => {
		dispatch(setProjectFilterReset());
	};
	return (
		<center>
			<ButtonGroup>
				<Button
					bsSize="small"
					onClick={resetFilter}>
					<span className="glyphicon glyphicon-repeat leftGlyph"></span>
					Clear
				</Button>
				<Button
					ref={closeButtonRef}
					bsSize="small"
					className="closeButton"
					aria-label="Close Views"
					onClick={closeButtonClick}>
					<span className="glyphicon glyphicon-remove-circle leftGlyph"></span>
					Close
				</Button>
			</ButtonGroup>
		</center>
	);
};

FlyoutRightButtons.propTypes = {
	setIsFlyoutRightActive: PropTypes.func,
	closeButtonRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.any })
	]),
	onRequestClose: PropTypes.func
};

export default FlyoutRightButtons;